export const events = {
  imports: {
    started: 'Universal Importer: Start Process',
    mappingRequested: 'Universal Importer: Mapping Requested',
    mappingRequestError: 'Universal Importer: Mapping Request Error',
    cancelled: 'Universal Importer: Process Cancelled',
    headerStep: 'Universal Importer: Move to Header Step',
    reviewStep: 'Universal Importer: Move to Review Step',
    attachFile: 'Universal Importer: Upload File',
    downloadTemplate: 'Universal Importer: Download Template',
  },
}
